import { render, staticRenderFns } from "./settingTime.vue?vue&type=template&id=54432bf0&scoped=true&"
import script from "./settingTime.vue?vue&type=script&lang=js&"
export * from "./settingTime.vue?vue&type=script&lang=js&"
import style0 from "./settingTime.vue?vue&type=style&index=0&id=54432bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54432bf0",
  null
  
)

export default component.exports